<template>
  <hm-content title="">
    <div slot="header">
      <hm-step :steps="steps" :step="2" disabledNext></hm-step>
    </div>
    <div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="规则名称" prop="ruleName">
          <el-input
            type="text"
            v-model.trim="ruleForm.ruleName"
            clearable
            placeholder="请输入规则名称"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="发 送 到：" prop="sendTargetType">
          <el-radio-group v-model="ruleForm.sendTargetType" size="small">
            <el-radio label="group">微信群</el-radio>
            <!-- <el-radio label="miniprogram">小程序</el-radio>
            <el-radio label="sms">短信</el-radio> -->
          </el-radio-group>
        </el-form-item>
        <el-form-item label="发送内容：" prop="sendContentType">
          <el-radio-group v-model="ruleForm.sendContentType" size="small">
            <el-radio label="template">消息模板</el-radio>
            <!-- <el-radio label="pic">消息图片</el-radio> -->
          </el-radio-group>
        </el-form-item>
        <el-form-item label="发送时间：" prop="sendTimeType">
          <el-radio-group v-model="ruleForm.sendTimeType" size="small">
            <el-radio label="realtime">实时发送</el-radio>
            <el-radio label="cron">定时发送</el-radio>
            <el-radio label="fixed">间隔发送</el-radio>
          </el-radio-group>
          <div class="form-item-tip">
            实时推送表示触发推送行为的事件发生则实时推送一条消息。
          </div>
          <div class="form-item-tip">
            定时推送指在某个时间点将需要发送的消息一次性推送。
          </div>
          <div v-if="ruleForm.sendTimeType === 'cron'">
            <el-time-select
              size="small"
              class="mr10"
              v-model="sendTimeValue"
              :picker-options="{
                start: '06:00',
                step: '00:01',
                end: '24:00'
              }"
              placeholder="请选择定时推送时间"
            >
            </el-time-select>
            <el-button type="text" size="small" @click="add">
              添加
            </el-button>
            <el-table
              stripe
              border
              :data="ruleForm.sendTimeList"
              style="width: 700px"
              id="table"
              size="small"
            >
              <el-table-column
                type="index"
                label="序号"
                header-align="center"
                align="center"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="sendTimeValue"
                label="发送时间"
              >
                <template slot-scope="scope">
                  {{ scope.row }}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="操作"
                width="100"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="remove(scope.$index)"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="ruleForm.sendTimeType === 'fixed'">
            <el-date-picker
              class="mr10"
              size="small"
              v-model="ruleForm.applyDate"
              type="datetimerange"
              :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            ></el-date-picker>
            <div>
              每隔
              <el-input
                clearable
                v-model.trim="ruleForm.fixedTimeValue"
                @input="filterGt0OrFixed0('fixedTimeValue')"
                size="small"
                style="width: 100px"
                class="ipt mr10"
              ></el-input>
              <el-select
                size="small"
                class="mr10"
                v-model="ruleForm.fixedTimeMode"
                style="width: 60px"
              >
                <el-option label="时" value="H"></el-option>
                <el-option label="分" value="M"></el-option>
              </el-select>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="发送方式：" prop="promotionName">
          <el-radio-group v-model="ruleForm.msgPackageMode" size="small">
            <el-radio label="single">单条一次发送</el-radio>
            <el-radio label="merge">多条合并发送</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="back"
            >上一步</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="submitRuleForm('ruleForm')"
            >确 认</el-button
          >
        </div>
      </el-form>
    </div>
  </hm-content>
</template>

<script>
import HmStep from "@/components/HmStep";
import { setCookie, getCookie, removeCookie } from "@/utils/utils";
export default {
  components: { HmStep },
  data() {
    const patternFunc = (rule, val, callback) => {
      if (val === "cron") {
        if (this.ruleForm.sendTimeList.length === 0) {
          return callback(new Error("请添加定时发送时间"));
        }
      } else if (val === "fixed") {
        if (
          !this.ruleForm.applyDate ||
          this.ruleForm.applyDate.length === 0 ||
          this.ruleForm.fixedTimeValue === "" ||
          this.ruleForm.fixedTimeMode === ""
        ) {
          return callback(new Error("请选择间隔发送时间规则"));
        }
      }
      callback();
    };
    return {
      sendTimeValue: "",
      rules: {
        ruleName: {
          required: true,
          message: "请输入规则名称",
          trigger: "blur"
        },
        sendTargetType: {
          required: true,
          message: "请选择发送位置",
          trigger: "blur"
        },
        sendContentType: {
          required: true,
          message: "请选择发送内容",
          trigger: "blur"
        },
        sendTimeType: [
          { required: true, message: "请选择发送时间", trigger: "blur" },
          {
            validator: patternFunc,
            trigger: "change"
          }
        ],
        msgPackageMode: {
          required: true,
          message: "请选择发送方式",
          trigger: "blur"
        }
      },
      ruleForm: {
        templateType: "",
        ruleName: "",
        sendTargetType: "",
        sendContentType: "",
        sendTimeType: "",
        msgPackageMode: "",
        sendTimeList: [],
        applyDate: [],
        fixedTimeValue: "",
        fixedTimeMode: "H"
      },
      disabledFirst: false,
      steps: [
        {
          link: "SendMsgRule",
          name: "选择模板类型"
        },
        {
          link: "SendRuleConfig",
          name: "发送规则配置"
        }
      ]
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    const STEP = getCookie({ key: "MSGRULESTEP" }) || {};
    if (STEP.hasOwnProperty("step2")) {
      for (let key in STEP.step2) {
        this.ruleForm[key] = STEP.step2[key];
      }
    }
    this.ruleForm.templateType = STEP.step1.templateType;
  },
  methods: {
    submitRuleForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = this.ruleForm;
          if (params.sendTimeType === "fixed") {
            params.fixedStartTime = params.applyDate[0];
            params.fixedEndTime = params.applyDate[1];
          }
          this.$store.dispatch("addWxMsgSendRule", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              removeCookie({ key: "MSGRULESTEP" });
              this.$router.push({
                name: "MessageSendManagement"
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    back() {
      const data = getCookie({ key: "MSGRULESTEP" });
      let step2 = this.ruleForm;
      Object.assign(data, { step2 });
      setCookie({ key: "MSGRULESTEP", data });
      this.$router.push({
        name: "SendMsgRule",
        query: {
          type: "sendRule"
        }
      });
    },
    filterGt0OrFixed0(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d]/g, "");
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "")
        .replace("-", "")
        .replace(",", "");
    },
    add() {
      if (this.sendTimeValue) {
        this.ruleForm.sendTimeList.push(this.sendTimeValue);
        const uniqueSet = new Set(this.ruleForm.sendTimeList);

        this.ruleForm.sendTimeList = [...uniqueSet];
      }
    },
    remove(i) {
      this.ruleForm.sendTimeList.splice(i, 1);
    }
  }
};
</script>
<style lang="scss" scoped></style>
